import React, { Component } from 'react';

import client from 'utils/client';

export default class ItemCounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemCounter: 0
    };
  }

  componentDidMount() {
    client.get('/cart/items/count/').then(res => {
      this.setState({
        itemCounter: res.data.count
      });
    });
  }

  render() {
    return (
      <span>
        {this.state.itemCounter ? (
          <div className="item-counter">
            <p>{this.state.itemCounter}</p>
          </div>
        ) : (
          <span />
        )}
      </span>
    );
  }
}
